import React from "react";
import { connect } from "react-redux";
import { PacmanLoader } from "react-spinners";
import { Card, Row, Col } from "reactstrap";
import { FormattedMessage } from "react-intl";
import NumberFormat from "react-number-format";

import { fetchInvoiceHistoryForAllCustomers } from "../../actions/invoiceHistoryActions";
import InvoiceItem from "../../components/Invoice/InvoiceItem";

class InvoiceHistory extends React.Component {
  componentDidMount() {
    this.props.dispatch(fetchInvoiceHistoryForAllCustomers());
  }

  render() {
    const { invoiceHistory } = this.props;

    if (invoiceHistory.loading) {
      return (
        <div
          className="sweet-loading"
          style={{ position: "fixed", top: "50%", left: "50%" }}
        >
          <PacmanLoader color={"#20a8d8"} loading={true} />
        </div>
      );
    }

    if (invoiceHistory.result.length === 0) {
      return (
        <Row>
          <Col sm="6" md="10">
            <Card body>
              <FormattedMessage id="Views.Teacher.InvoiceHistory.NoInvoicesToShow" />
            </Card>
          </Col>
        </Row>
      );
    }

    const reducer = (accumulator, currentValue) => accumulator + currentValue;

    return (
      <div className="animated fadeIn">
        <Card body style={{ maxHeight: "250px" }}>
          <h4>
            <FormattedMessage id="OrderHistory" />
          </h4>
          <h6 className="text-muted mb-0">
            <FormattedMessage id="NumberOfOrders" />{" "}
            {invoiceHistory.result.length} <FormattedMessage id="PiecesShort" />{" "}
            <FormattedMessage id="SumTotal" />{" "}
            <NumberFormat
              value={invoiceHistory.result.map(r => r.price).reduce(reducer)}
              displayType={"text"}
              thousandSeparator={" "}
            />{" "}
            <FormattedMessage id="SEK" />
          </h6>
        </Card>
        <Card body>
          {invoiceHistory.result
            .sort((a, b) => a.created > b.created)
            .map((invoice, i) => {
              return (
                <InvoiceItem key={i} invoice={invoice} fortNoxDisplay={true} />
              );
            })}
        </Card>
      </div>
    );
  }
}

const mapStateToProps = store => {
  return {
    invoiceHistory: store.invoiceHistoryReducer
  }
}

export default connect(mapStateToProps)(InvoiceHistory);